export const LumaSpin = () => {
  return (
    <div className="relative w-[65px] aspect-square">
      <span className="absolute rounded-[50px] animate-loaderAnim shadow-[inset_0_0_0_3px] shadow-foreground" />
      <span className="absolute rounded-[50px] animate-loaderAnim animation-delay-loader shadow-[inset_0_0_0_3px] shadow-foreground" />
    </div>
  );
};
